<template>
  <section class="quick-tray" :class="{ 'quick-tray--open': isOpen }">
    <transition name="quick-tray-content">
      <div v-if="isOpen" id="operational-quick-actions" class="quick-tray__panel">
        <div class="quick-tray__heading">
          <span class="quick-tray__eyebrow">Akses cepat</span>
          <strong>Operasional Utama</strong>
        </div>

        <nav class="quick-tray__actions" aria-label="Akses cepat operasional utama">
          <router-link
            v-for="action in visibleActions"
            :key="action.path"
            :to="action.path"
            class="quick-tray__action"
            active-class="quick-tray__action--active"
            @click.native="isOpen = false"
          >
            <span class="quick-tray__icon" aria-hidden="true">
              <i :class="action.icon"></i>
            </span>
            <span>{{ action.label }}</span>
          </router-link>
        </nav>
      </div>
    </transition>

    <button
      type="button"
      class="quick-tray__toggle"
      :aria-expanded="isOpen ? 'true' : 'false'"
      aria-controls="operational-quick-actions"
      :title="isOpen ? 'Tutup akses cepat' : 'Buka akses cepat operasional'"
      @click="isOpen = !isOpen"
    >
      <i :class="isOpen ? 'fas fa-chevron-up' : 'fas fa-bolt'" aria-hidden="true"></i>
      <span>{{ isOpen ? 'Tutup' : 'Akses Cepat' }}</span>
      <i :class="isOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" aria-hidden="true"></i>
    </button>
  </section>
</template>

<script>
import { loadQuickAccess } from "@/core/services/quick-access.service";

export default {
  name: "QuickAccessTray",
  data() {
    return {
      isOpen: false,
      selectedActions: ["appointment-add", "appointment-list", "patient-list", "payment-list", "pharmacy-cashier"],
      actions: [
        { id: "appointment-add", label: "Pendaftaran Baru", path: "/appointment/add", icon: "fas fa-calendar-plus", access: "5002" },
        { id: "appointment-today", label: "Kunjungan Hari Ini", path: "/appointment/todays", icon: "fas fa-calendar-day", access: "5001" },
        { id: "appointment-list", label: "Semua Pendaftaran", path: "/appointment/list/0", icon: "fas fa-clipboard-list", access: "5001" },
        { id: "queue", label: "Antrean Klinik", path: "/queue", icon: "fas fa-ticket-alt", access: "5001" },
        { id: "patient-add", label: "Tambah Pasien", path: "/patient/add", icon: "fas fa-user-plus", access: "3002" },
        { id: "patient-list", label: "Cari Pasien", path: "/patient/list", icon: "fas fa-user-injured", access: "3001" },
        { id: "medical-records", label: "Rekam Medis", path: "/patient/cases", icon: "fas fa-notes-medical", access: "3005" },
        { id: "prescriptions", label: "Resep Pasien", path: "/prescriptions/list", icon: "fas fa-prescription", access: "8001" },
        { id: "medical-actions", label: "Worklist Tindakan", path: "/medical-actions/requests", icon: "fas fa-procedures", access: "1202" },
        { id: "lab", label: "Operasional Lab", path: "/lab-report-2/operations", icon: "fas fa-microscope", access: "1104" },
        { id: "payment-list", label: "Kasir & Pembayaran", path: "/payment/list", icon: "fas fa-cash-register", access: "6001" },
        { id: "payment-add", label: "Pembayaran Baru", path: "/payment/add", icon: "fas fa-file-invoice-dollar", access: "6002" },
        { id: "pharmacy-workflow", label: "Worklist Farmasi", path: "/pharmacy/workflow", icon: "fas fa-tasks", access: "1401" },
        { id: "pharmacy-cashier", label: "Kasir Apotek", path: "/pharmacy/cashier", icon: "fas fa-prescription-bottle-alt", access: "1402" },
        { id: "pharmacy-sales", label: "Penjualan Apotek", path: "/pharmacy/sales", icon: "fas fa-receipt", access: "1401" },
        { id: "medicine-list", label: "Daftar Obat & Alkes", path: "/medicine/list", icon: "fas fa-capsules", access: "9001" },
        { id: "medicine-stock", label: "Stok Obat", path: "/medicine/maintain-stock", icon: "fas fa-boxes", access: "9004" },
        { id: "stock-opname", label: "Stok Opname", path: "/stock-opnames/list", icon: "fas fa-clipboard-check", access: "9009" },
        { id: "inpatient", label: "Rawat Inap", path: "/inpatient", icon: "fas fa-hospital-user", access: "1301" },
        { id: "home-care", label: "Ringkasan Home Care", path: "/home-care", icon: "fas fa-house-user", access: "10601" },
        { id: "bpjs-participant", label: "Verifikasi BPJS", path: "/bpjs/peserta", icon: "fas fa-id-card", access: null },
      ],
    };
  },
  computed: {
    visibleActions() {
      let accessRights = [];
      try {
        accessRights = JSON.parse(window.localStorage.getItem("access_right_display") || "[]");
      } catch (error) {
        accessRights = [];
      }
      const normalizedAccessRights = accessRights.map(access => String(access));
      return this.actions.filter(action =>
        this.selectedActions.includes(action.id) &&
        (!action.access || normalizedAccessRights.includes(action.access))
      );
    },
  },
  async mounted() {
    await this.loadSelection();
    window.addEventListener("medhop-quick-access-updated", this.handleSelectionUpdated);
  },
  beforeDestroy() {
    window.removeEventListener("medhop-quick-access-updated", this.handleSelectionUpdated);
  },
  methods: {
    async loadSelection() {
      const saved = await loadQuickAccess();
      if (Array.isArray(saved)) this.selectedActions = saved;
    },
    handleSelectionUpdated(event) {
      if (event && Array.isArray(event.detail)) this.selectedActions = event.detail.slice(0, 7);
      else void this.loadSelection();
    },
  },
};
</script>

<style lang="scss" scoped>
.quick-tray {
  position: sticky;
  top: 65px;
  z-index: 1025;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  width: 100%;
  min-height: 18px;
  background: transparent;
}

.quick-tray__panel {
  width: 100%;
  padding: 12px clamp(16px, 2.2vw, 30px) 17px;
  display: flex;
  align-items: center;
  gap: 24px;
  background: rgba(255, 255, 255, 0.98);
  border-bottom: 1px solid #dce6ef;
  box-shadow: 0 12px 28px rgba(15, 49, 83, 0.12);
}

.quick-tray__heading {
  min-width: 150px;
  display: flex;
  flex-direction: column;
  color: #172b46;

  strong { font-size: 0.95rem; line-height: 1.25; }
}

.quick-tray__eyebrow {
  margin-bottom: 2px;
  color: #168c87;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.quick-tray__actions {
  display: flex;
  flex: 1;
  flex-wrap: nowrap;
  gap: 8px;
  min-width: 0;
}

.quick-tray__action {
  min-width: 0;
  flex: 1 1 0;
  min-height: 48px;
  padding: 7px 11px;
  display: flex;
  align-items: center;
  gap: 9px;
  color: #314861;
  font-size: 0.825rem;
  font-weight: 700;
  background: #f6f9fc;
  border: 1px solid #e1e8ef;
  border-radius: 11px;
  transition: 160ms ease;

  &:hover, &:focus, &--active {
    color: #0f5f7e;
    text-decoration: none;
    background: #ebf7f6;
    border-color: #a9dcd7;
    transform: translateY(-1px);
  }
}

.quick-tray__icon {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #168c87;
  background: #e1f4f1;
  border-radius: 9px;
}

.quick-tray__toggle {
  min-width: 142px;
  height: 25px;
  padding: 0 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #f7ffff;
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  background: linear-gradient(100deg, #123769, #178d8b);
  border: 0;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 6px 14px rgba(14, 56, 91, 0.2);
  cursor: pointer;

  &:hover, &:focus { outline: none; filter: brightness(1.08); }
  i { font-size: 0.63rem; }
}

.quick-tray__toggle i,
.quick-tray__toggle:hover i,
.quick-tray__toggle:focus i {
  color: #ffffff !important;
}

.quick-tray-content-enter-active,
.quick-tray-content-leave-active { transition: 180ms ease; transform-origin: top; }
.quick-tray-content-enter,
.quick-tray-content-leave-to { opacity: 0; transform: translateY(-8px) scaleY(0.96); }

@media (max-width: 991px) {
  .quick-tray { top: 58px; }
  .quick-tray__panel { padding: 10px 12px 15px; gap: 12px; }
  .quick-tray__heading { display: none; }
  .quick-tray__actions { display: flex; overflow: hidden; padding-bottom: 2px; }
  .quick-tray__action { min-width: 0; flex: 1 1 0; flex-direction: column; justify-content: center; gap: 4px; text-align: center; font-size: 0.7rem; }
  .quick-tray__icon { width: 28px; height: 28px; flex-basis: 28px; }
}

@media (max-width: 575px) {
  .quick-tray { top: 54px; }
  .quick-tray__actions { display: flex; gap: 5px; }
  .quick-tray__panel { box-shadow: 0 8px 20px rgba(15, 49, 83, 0.14); }
  .quick-tray__toggle { min-width: 126px; font-size: 0.62rem; }
  .quick-tray__action { min-height: 44px; padding: 5px 3px; border-radius: 9px; }
  .quick-tray__action > span:last-child { display: none; }
  .quick-tray__icon { width: 30px; height: 30px; flex-basis: 30px; }
}
</style>
